



import { FilterItem } from '@/interfaces/filter-items';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { Vue, Component, PropSync } from 'vue-property-decorator';
@Component
export default class JobFilter extends mixins(DictMixin) {
  @PropSync('name') nameSync!: any;

  filterItems: FilterItem[] = [];

  created() {
    this.init();
  }

  init() {
    if (!this.DICT_JOB_DISPOSE_STATUS) {
      setTimeout(() => {
        this.init();
      }, 100);
    } else {
      this.filterItems = [
        {
          label: '作业编码',
          key: 'jobCode_like',
          type: 'input'
        },
        {
          label: this.nameSync,
          key: 'jobNameEx_like',
          type: 'input'
        },
        {
          label: '最新处理状态',
          key: 'handleStatus_eq',
          type: 'select',
          options: this.DICT_JOB_DISPOSE_STATUS
        }
      ];
    }
  }

  excuteFilter(res: object) {
    this.$emit('reload', res);
  }

  resetFilter() {
    this.$emit('reload', {});
  }
}
